import React, {useEffect, useState} from 'react';
import '../App.css';
import { Form } from 'react-bootstrap';
import { Modal, Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import { Hint } from 'react-autocomplete-hint';
import Bodyheaderloged from './bodyheaderloged'
import io from 'socket.io-client';

function Bodygestionproductos (props){
    const [datosListaCategoria, setDatosListaCategoria] = useState([]);
    const [datosListaDisponibilidad, setDatosListaDisponibilidad] = useState([]);
    const [datosProductos, setDatosProductos] = useState([]);
    const [categoriaProductoCafeteriaId, setCategoriaProductoCafeteriaId] = useState('')
    const [disponibilidadProductoCafeteriaId, setDisponibilidadProductoCafeteriaId] = useState('')
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);
    
    const [file, setFile] = useState("");
    const [fileName, setFileName] = useState("")
    const [codigoBarra, setCodigoBarra] = useState('');
    const [nombreProducto, setNombreProducto] = useState('');
    const [precioProducto, setPrecioProducto] = useState('');
    const [existenciaProducto, setExistenciaProducto] = useState('');
    const [categoriaProductoCafeteriaIdCrear, setCategoriaProductoCafeteriaIdCrear] = useState('1')
    const [disponibilidadProductoCafeteriaIdCrear, setDisponibilidadProductoCafeteriaIdCrear] = useState('1')


    const [fileEditar, setFileEditar] = useState("");
    const [fileNameEditar, setFileNameEditar] = useState("")
    const [idEditar, setIdEditar] = useState();
    const [codigoBarraEditar, setCodigoBarraEditar] = useState('');
    const [nombreProductoEditar, setNombreProductoEditar] = useState('');
    const [precioProductoEditar, setPrecioProductoEditar] = useState('');
    const [existenciaProductoEditar, setExistenciaProductoEditar] = useState('');
    const [categoriaProductoCafeteriaIdEditar, setCategoriaProductoCafeteriaIdEditar] = useState('')
    const [disponibilidadProductoCafeteriaIdEditar, setDisponibilidadProductoCafeteriaIdEditar] = useState('')

    const [idEliminar, setIdEliminar] = useState();

    const [feedback, setFeedback] = useState({
        show: false,    // Determina si el alert se muestra
        message: '',    // El mensaje a mostrar
        variant: 'success',  // El tipo de alert: 'success', 'danger', 'info', etc.
    });

    const [feedback1, setFeedback1] = useState({
        show: false,    // Determina si el alert se muestra
        message: '',    // El mensaje a mostrar
        variant: 'success',  // El tipo de alert: 'success', 'danger', 'info', etc.
    });

    const [message, setMessage] = useState();
    const [variant, setVariant] = useState();

    const [nombreCategoriaCrear, setNombreCategoriaCrear] = useState();
    const [categoriaEditar, setCategoriaEditar] = useState();
    const [categoriaEliminar, setCategoriaEliminar] = useState();

    const [nombreCategoriaEditar, setNombreCategoriaEditar] = useState("");
    const [idCategoriaEditar, setIdCategoriaEditar] = useState();

    const [nombreCategoriaEliminar, setNombreCategoriaEliminar] = useState("");
    const [idCategoriaEliminar, setIdCategoriaEliminar] = useState();

    const productosList = datosProductos.map((item, i) => (
        <tr key={i}>
          <td className="px-6 py-3 text-sm text-gray-600">{item.codigo_barra}</td>
          <td className="px-6 py-3 text-sm text-gray-600">{item.nombre}</td>
          <td className="px-6 py-3 text-sm text-gray-600">{item.precio}</td>
          <td className="px-6 py-3 text-sm text-gray-600">{item.categoria}</td>
          <td className="px-6 py-3 text-sm text-gray-600">{item.existencia}</td>
          <td className="px-6 py-3 text-sm text-gray-600">
            <button className="text-blue-500 hover:text-blue-600" onClick={() => {editarProducto(item);}}>Editar</button>
            <button className="text-red-500 hover:text-red-600 ml-4" onClick={() => {eliminarProducto(item);}}>Eliminar</button>
          </td>
        </tr>
    ));

    const categoriasList = datosListaCategoria.map((item, i) => (
        <tr key={i}>
          <td className="px-6 py-3 text-sm text-gray-600">{item.nombre}</td>
          <td className="px-6 py-3 text-sm text-gray-600">
            <button className="text-blue-500 hover:text-blue-600" onClick={() => {editarCategoria(item);}}>Editar</button>
            <button className="text-red-500 hover:text-red-600 ml-4" onClick={() => {eliminarCategoria(item);}}>Eliminar</button>
          </td>
        </tr>
    ));

      // Handler para el input de imagen
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name)
    }

    const handlerCodigoBarra = (e) => setCodigoBarra(e.target.value)
    const handlerNombreProducto = (e) => setNombreProducto(e.target.value)
    const handlerPrecioProducto = (e) => setPrecioProducto(e.target.value)
    const handlerExistenciaProducto = (e) => setExistenciaProducto(e.target.value)
    
    const handleCategoriaChangeCrear = (e) => {
        const selectedValue = e.target.value; // Obtener el valor seleccionado
        setCategoriaProductoCafeteriaIdCrear(selectedValue); // Actualizar el estado
    };

    const handleDisponibilidadChangeCrear = (e) => {
        const selectedValue = e.target.value; // Obtener el valor seleccionado
        setDisponibilidadProductoCafeteriaIdCrear(selectedValue); // Actualizar el estado
    };

    const handleFileChangeEditar = (e) => {
        setFileEditar(e.target.files[0]);
        setFileNameEditar(e.target.files[0].name)
    }

    const handlerNombreCategoriaCrear = (e) => {
        setNombreCategoriaCrear(e.target.value)
    }


    const handlerCodigoBarraEditar = (e) => setCodigoBarraEditar(e.target.value)
    const handlerNombreProductoEditar = (e) => setNombreProductoEditar(e.target.value)
    const handlerPrecioProductoEditar = (e) => setPrecioProductoEditar(e.target.value)
    const handlerExistenciaProductoEditar = (e) => setExistenciaProductoEditar(e.target.value)
    
    const handleCategoriaChangeEditar = (e) => {
        console.log(e.target.value)
        const selectedValue = e.target.value; // Obtener el valor seleccionado
        setCategoriaProductoCafeteriaIdEditar(selectedValue); // Actualizar el estado
    };

    const handleDisponibilidadChangeEditar = (e) => {
        console.log(e.target.value)
        const selectedValue = e.target.value; // Obtener el valor seleccionado
        setDisponibilidadProductoCafeteriaIdEditar(selectedValue); // Actualizar el estado
    };    

    const editarProducto = (item) =>
    {
        setShow1(true);
        setCodigoBarraEditar(item.codigo_barra)
        setNombreProductoEditar(item.nombre)
        setPrecioProductoEditar(item.precio)
        setExistenciaProductoEditar(item.existencia) 
        setCategoriaProductoCafeteriaIdEditar(item.id_categoria)
        setDisponibilidadProductoCafeteriaIdEditar(item.id_disponibilidad)
        setIdEditar(item.id)
    }

    const editarCategoria = (item) =>
    {
        setShow4(true);
        setNombreCategoriaEditar(item.nombre)
        setIdCategoriaEditar(item.id)
    }

    const eliminarCategoria = (item) =>
    {
        setShow5(true);
        setNombreCategoriaEliminar(item.nombre)
        setIdCategoriaEliminar(item.id)

    }

    const eliminarProducto = (item) =>
    {
        setIdEliminar(item.id)
        setShow2(true);
    }

    // Función para abrir el modal
    const handleShow = () => setShow(true);

    // Función para cerrar el modal
    const handleClose = () => setShow(false);
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    const handleClose4 = () => setShow4(false);
    const handleClose5 = () => setShow5(false);

    const handleCategoriaChange = (e) => {
        const selectedValue = e.target.value; // Obtener el valor seleccionado
        setCategoriaProductoCafeteriaId(selectedValue); // Actualizar el estado
    };

    const handlerNombreCategoriaEditar = (e) => {
        setNombreCategoriaEditar(e.target.value)
    }

    const handleDisponibilidadChange = (e) => {
        const selectedValue = e.target.value; // Obtener el valor seleccionado
        setDisponibilidadProductoCafeteriaId(selectedValue); // Actualizar el estado
    };



    const GetListas = () =>
    {    
        let idcasinouserfront = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            
        Axios.get(process.env.REACT_APP_URLMANTENEDORPRODUCTOSLISTAS, {
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {        
            setDatosListaCategoria(response.data.categorias)
            setDatosListaDisponibilidad(response.data.disponibilidad)
        }).catch(error => {
            return error     
        });
    }    

    const GetProductos = () =>
    {    
            let idcasinouserfront = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            Axios.get(process.env.REACT_APP_URLMANTENEDORPRODUCTOSBYCATEGORIA, {
                params: {
                    casino_id: idcasinouserfront,
                    categoria_producto_cafeteria_id: categoriaProductoCafeteriaId || ''
                }, 
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }
            }).then((response) => {        
                setDatosProductos(response.data.productos)
            }).catch(error => {
                return error     
            });
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        let casino_id = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        const formData = new FormData();
        formData.append('codigo_barra', codigoBarra);
        formData.append('nombre', nombreProducto);
        formData.append('precio', precioProducto);
        formData.append('casino_id', casino_id);
        formData.append('existencia', existenciaProducto);
        formData.append('disponibilidad', disponibilidadProductoCafeteriaIdCrear);
        formData.append('categoria_producto', categoriaProductoCafeteriaIdCrear);
        formData.append("file", file);
        formData.append("fileName", fileName);
    
        try {
          const response = await Axios.post(process.env.REACT_APP_URLMANTENEDORPRODUCTOSCREAR, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          
          GetProductos();
          setShow(false);

          setFeedback({
              show: true,
              message: "Producto creado con éxito",
              variant: "success",
          });
  
          setTimeout(() => {
              setFeedback({
                  show: false,
                  message: '',
                  variant: 'success',
              });
          }, 5000);
        } catch (error) {
            setShow(false);
            GetProductos();
  
            setFeedback({
                show: true,
                message: error,
                variant: "danger",
            });

            setTimeout(() => {
                setFeedback({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);            
        }
    };

    const handlerCreaCategoria = async (e) =>{
        const formData = new FormData();
        formData.append("nombre", nombreCategoriaCrear);
    
        try {
          const response = await Axios.post(process.env.REACT_APP_URLMANTENEDORCATEGORIACREAR, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          if(response.statusText == "OK")
          {
            GetListas()
            setShow(false);
            setNombreCategoriaCrear("")
            setFeedback1({
                show: true,
                message: "Categoria creada con éxito",
                variant: "success",
            });
    
            setTimeout(() => {
                setFeedback1({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);
          }
        } catch (error) {
            setShow(false);  
            setFeedback1({
                show: true,
                message: error,
                variant: "danger",
            });
    
            setTimeout(() => {
                setFeedback1({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);            
        }        
    };

    const handleEditarSubmit = async (e) => {
        e.preventDefault();

        let casino_id = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        const formData = new FormData();
        formData.append('codigo_barra', codigoBarraEditar);
        formData.append('nombre', nombreProductoEditar);
        formData.append('precio', precioProductoEditar);
        formData.append('casino_id', casino_id);
        formData.append('existencia', existenciaProductoEditar);
        formData.append('disponibilidad', disponibilidadProductoCafeteriaIdEditar);
        formData.append('categoria_producto', categoriaProductoCafeteriaIdEditar);
        formData.append('id', idEditar)
        if(fileEditar != "")
        {
            formData.append("file", fileEditar);
            formData.append("fileName", fileNameEditar);            
        }
        else{
            formData.append("file", "");
            formData.append("fileName", "");
        }

    
        try {
          const response = await Axios.post(process.env.REACT_APP_URLMANTENEDORPRODUCTOSEDITAR, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          setShow1(false);
          GetProductos();

          setFeedback({
              show: true,
              message: "Producto editado con éxito",
              variant: "success",
          });
  
          setTimeout(() => {
              setFeedback({
                  show: false,
                  message: '',
                  variant: 'success',
              });
          }, 5000);
        
        } catch (error) {
            setShow1(false);
  
            setFeedback({
                show: true,
                message: error,
                variant: "danger",
            });
    
            setTimeout(() => {
                setFeedback({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);            
        }    
    };

    const handleConfirmarEliminarCategoria = async () =>{
        try {
            const response = await Axios.delete(process.env.REACT_APP_URLMANTENEDORCATEGORIAELIMINAR, {
                data: { categoria_id: idCategoriaEliminar } // Enviamos el id en el cuerpo de la solicitud
            });

            if(response.statusText == "OK")
            {
                setShow5(false);
                GetListas();
    
                setFeedback1({
                    show: true,
                    message: "Categoria eliminada con exito",
                    variant: "success",
                });

                setTimeout(() => {
                    setFeedback1({
                        show: false,
                        message: '',
                        variant: 'success',
                    });
                }, 5000);         
            }
        } catch (error) {
            setShow2(false);
            setFeedback1({
                show: true,
                message: error.message,
                variant: "danger",
            });
    
            setTimeout(() => {
                setFeedback1({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);
        }
    }

    const handleConfirmarEliminar = async () =>{
        try {
            const response = await Axios.delete(process.env.REACT_APP_URLMANTENEDORPRODUCTOSELIMINAR, {
                data: { producto_id: idEliminar } // Enviamos el id en el cuerpo de la solicitud
            });

            setShow2(false);
            GetProductos();

            setFeedback({
                show: true,
                message: "Producto eliminado con exito",
                variant: "success",
            });
    
            setTimeout(() => {
                setFeedback({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);            

        } catch (error) {
            setShow2(false);
            setFeedback({
                show: true,
                message: error.message,
                variant: "danger"
            });
    
            setTimeout(() => {
                setFeedback({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);
        }
    }

    const handleEditarCategoriaSubmit = async () =>{
        const formData = new FormData();
        formData.append('nombre', nombreCategoriaEditar)
        formData.append('categoria_id', idCategoriaEditar)     
        try {
          const response = await Axios.post(process.env.REACT_APP_URLMANTENEDORCATEGORIAEDITAR, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });

          if(response.statusText == "OK")
          {
            setShow4(false);
            GetListas()
  
            setFeedback1({
                show: true,
                message: "Categoria editada con éxito",
                variant: "success",
            });
    
            // Después de 5 segundos, ocultamos el mensaje
            setTimeout(() => {
                setFeedback1({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);
          }
        } catch (error) {
            setShow4(false);
            setFeedback1({
                show: true,
                message: error,
                variant: "danger"
            });
    
            setTimeout(() => {
                setFeedback1({
                    show: false,
                    message: '',
                    variant: 'success',
                });
            }, 5000);            
        }        
    }

    useEffect(() => {
        GetListas()
        GetProductos()
    }, [categoriaProductoCafeteriaIdEditar, disponibilidadProductoCafeteriaIdEditar]);

    return (
        <div className="w-full p-6 bg-gray-50">
          <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
          </div>  
          {/* Título Principal */}
          <div className="text-center my-8">
            <h1 className="text-3xl font-bold text-gray-800">Mantenedor de Productos</h1>
            <p className="text-lg text-gray-600">Gestión de productos y categorías para el sistema de casinos</p>
          </div>
    
          {/* Filtros y Opciones Principales */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">    
            <div>
              <label htmlFor="categoria" className="block text-sm font-medium text-gray-700">Seleccionar Categoría</label>
              <select
                id="categoria"
                className="w-full mt-2 px-4 py-2 border rounded-md bg-white text-gray-700"
                onChange={handleCategoriaChange} // Agregar el onChange aquí
                value={categoriaProductoCafeteriaId} // Establecer el valor del select
            >
                {/* Aquí estamos mapeando las categorías en las opciones del select */}
                {datosListaCategoria.length > 0 ? (
                    datosListaCategoria.map((categoria) => (
                        <option key={categoria.id} value={categoria.id}> {/* Usar id como value */}
                            {categoria.nombre}
                        </option>
                    ))
                ) : (
                    <option disabled>Cargando categorías...</option> // Opción que se muestra mientras se cargan los datos
                )}
            </select>
            </div>
    
            <div className="flex items-center justify-center space-x-4 mt-4 md:mt-0">
              <button className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700" onClick={GetProductos}>Listar Productos</button>
              <button className="px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700" onClick={handleShow}>Crear Producto</button>
            </div>
          </div>
    
    

    
          {/* Listado de Productos */}
          <div className="card mb-8 p-6 bg-white rounded-md shadow-md">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Listado de Productos</h2>
                {/* Condicional para mostrar el Alert */}
                {feedback.show && (
                <Alert 
                    variant={feedback.variant} 
                    onClose={() => setFeedback({ show: false, message: '', variant: 'success' })} 
                    dismissible
                    className="fixed top-0 left-1/2 transform -translate-x-1/2 z-50 w-full sm:w-auto m-4"
                >
                    {feedback.message}
                </Alert>
            )}    
            {/* Tabla de Productos */}
            <div className="overflow-x-auto">
                <table className="min-w-full table-auto border-collapse" style={{ tableLayout: 'fixed' }}>
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Código Barra</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Nombre</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Precio</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Categoría</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Existencia</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Acciones</th>
                    </tr>
                    </thead>
                </table>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="min-w-full table-auto border-collapse" style={{ tableLayout: 'fixed' }}>
                    <tbody>
                        {productosList.length > 0 ? (
                        productosList
                        ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-3 text-sm text-gray-600">No hay productos disponibles</td>
                        </tr>
                        )}
                    </tbody>
                    </table>
                </div>
            </div>
          </div>
    
          {/* Mantenedor de Categorías */}
          <div className="card mb-8 p-6 bg-white rounded-md shadow-md">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Mantenedor de Categorías</h2>
                {/* Condicional para mostrar el Alert */}
                {feedback1.show && (
                <Alert 
                    variant={feedback1.variant} 
                    onClose={() => setFeedback1({ show: false, message: '', variant: 'success' })} 
                    dismissible
                    className="fixed top-0 left-1/2 transform -translate-x-1/2 z-50 w-full sm:w-auto m-4"
                >
                    {feedback1.message}
                </Alert>
            )}    
            {/* Formulario de Creación/Modificación de Categoría */}
            
              <div className="flex flex-col mb-4">
                <label htmlFor="nombre_categoria" className="text-sm font-medium text-gray-700">Nombre de la Categoría</label>
                <input type="text" value={nombreCategoriaCrear} id="nombre_categoria" onChange={handlerNombreCategoriaCrear} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>
              <div className="flex justify-center mt-6">
                <button onClick={handlerCreaCategoria} className="px-6 py-3 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">Guardar Categoría</button>
              </div>
            
    
            {/* Listado de Categorías */}
            <div className="mt-6">
              <h3 className="text-lg font-semibold text-gray-700">Listado de Categorías</h3>
              <table className="min-w-full table-auto border-collapse mt-4">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Categoría</th>
                    <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Acciones</th>
                  </tr>
                </thead>
              </table>

                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="min-w-full table-auto border-collapse" style={{ tableLayout: 'fixed' }}>
                    <tbody>
                        {categoriasList.length > 0 ? (
                        categoriasList
                        ) : (
                        <tr>
                            <td colSpan="6" className="text-center py-3 text-sm text-gray-600">No hay productos disponibles</td>
                        </tr>
                        )}
                    </tbody>
                    </table>
                </div>             
            </div>
          </div>


      {/* Modal de Crear Producto */}
      <Modal show={show} onHide={handleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Crear Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card mb-8 p-6 bg-white rounded-md shadow-md">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Crear Producto</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Código de Barra */}
              <div className="flex flex-col">
                <label htmlFor="codigo_barra" className="text-sm font-medium text-gray-700">Código de Barra</label>
                <input type="text" id="codigo_barra" value={codigoBarra} onChange={handlerCodigoBarra} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Nombre del Producto */}
              <div className="flex flex-col">
                <label htmlFor="nombre" className="text-sm font-medium text-gray-700">Nombre del Producto</label>
                <input type="text" id="nombre" value={nombreProducto} onChange={handlerNombreProducto} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Precio */}
              <div className="flex flex-col">
                <label htmlFor="precio" className="text-sm font-medium text-gray-700">Precio</label>
                <input type="number" id="precio" value={precioProducto} onChange={handlerPrecioProducto} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Existencia (Stock) */}
              <div className="flex flex-col">
                <label htmlFor="existencia" className="text-sm font-medium text-gray-700">Existencia</label>
                <input type="number" id="existencia" value={existenciaProducto} onChange={handlerExistenciaProducto} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Disponibilidad */}
              <div className="flex flex-col">
                <label htmlFor="disponibilidad" className="text-sm font-medium text-gray-700">Disponibilidad</label>
                <select id="disponibilidad"  
                        className="mt-2 p-3 border rounded-md bg-gray-50"
                        onChange={handleDisponibilidadChangeCrear} // Agregar el onChange aquí
                        value={disponibilidadProductoCafeteriaIdCrear} // Establecer el valor del select
                    >
                        {/* Aquí estamos mapeando las categorías en las opciones del select */}
                        {datosListaDisponibilidad.length > 0 ? (
                            datosListaDisponibilidad.map((disponibilidad) => (
                                <option key={disponibilidad.id} value={disponibilidad.id}> {/* Usar id como value */}
                                    {disponibilidad.nombre}
                                </option>
                            ))
                        ) : (
                            <option disabled>Cargando categorías...</option> // Opción que se muestra mientras se cargan los datos
                        )}
                </select>
              </div>

              {/* Imagen del Producto */}
              <div className="flex flex-col">
                <label htmlFor="imagen" className="text-sm font-medium text-gray-700">Imagen</label>
                <input type="file" id="imagen" onChange={handleFileChange} className="mt-2 p-3 border rounded-md bg-gray-50" />
              </div>

              {/* Categoría del Producto */}
              <div className="flex flex-col">
                <label htmlFor="categoria_producto" className="text-sm font-medium text-gray-700">Categoría</label>
                <select id="categoria_producto" 
                        className="mt-2 p-3 border rounded-md bg-gray-50"
                        onChange={handleCategoriaChangeCrear} // Agregar el onChange aquí
                        value={categoriaProductoCafeteriaIdCrear} // Establecer el valor del select
                    >
                        {/* Aquí estamos mapeando las categorías en las opciones del select */}
                        {datosListaCategoria.length > 0 ? (
                            datosListaCategoria.map((categoria) => (
                                <option key={categoria.id} value={categoria.id}> {/* Usar id como value */}
                                    {categoria.nombre}
                                </option>
                            ))
                        ) : (
                            <option disabled>Cargando categorías...</option> // Opción que se muestra mientras se cargan los datos
                        )}
                </select>
              </div>
            </div>

            <div className="flex justify-center mt-6">
              <button className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700" onClick={handleSubmit}>Guardar Producto</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal de Editar Producto */}
      <Modal show={show1} onHide={handleClose1} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Editar Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card mb-8 p-6 bg-white rounded-md shadow-md">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Editar Producto</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Código de Barra */}
              <div className="flex flex-col">
                <label htmlFor="codigo_barra" className="text-sm font-medium text-gray-700">Código de Barra</label>
                <input type="text" id="codigo_barra" value={codigoBarraEditar} onChange={handlerCodigoBarraEditar} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Nombre del Producto */}
              <div className="flex flex-col">
                <label htmlFor="nombre" className="text-sm font-medium text-gray-700">Nombre del Producto</label>
                <input type="text" id="nombre" value={nombreProductoEditar} onChange={handlerNombreProductoEditar} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Precio */}
              <div className="flex flex-col">
                <label htmlFor="precio" className="text-sm font-medium text-gray-700">Precio</label>
                <input type="number" id="precio" value={precioProductoEditar} onChange={handlerPrecioProductoEditar} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Existencia (Stock) */}
              <div className="flex flex-col">
                <label htmlFor="existencia" className="text-sm font-medium text-gray-700">Existencia</label>
                <input type="number" id="existencia" value={existenciaProductoEditar} onChange={handlerExistenciaProductoEditar} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>

              {/* Disponibilidad */}
              <div className="flex flex-col">
                <label htmlFor="disponibilidad" className="text-sm font-medium text-gray-700">Disponibilidad</label>
                <select 
                    id="disponibilidad"
                    className="mt-2 p-3 border rounded-md bg-gray-50"
                    onChange={handleDisponibilidadChangeEditar} // Maneja el cambio de disponibilidad
                    value={disponibilidadProductoCafeteriaIdEditar || ""} // Vincula el valor del select al estado
                >
                    {datosListaDisponibilidad.length > 0 ? (
                        datosListaDisponibilidad.map((disponibilidad) => (
                            <option 
                                key={disponibilidad.id} 
                                value={disponibilidad.id} // El value es el id
                            >
                                {disponibilidad.nombre}
                            </option>
                        ))
                    ) : (
                        <option disabled>Cargando disponibilidades...</option>
                    )}
                </select>
              </div>

              {/* Imagen del Producto */}
              <div className="flex flex-col">
                <label htmlFor="imagen" className="text-sm font-medium text-gray-700">Imagen</label>
                <input type="file" id="imagen" onChange={handleFileChangeEditar} className="mt-2 p-3 border rounded-md bg-gray-50" />
              </div>

              {/* Categoría del Producto */}
              <div className="flex flex-col">
                <label htmlFor="categoria_producto" className="text-sm font-medium text-gray-700">Categoría</label>
                <select 
    id="categoria_producto"
    className="mt-2 p-3 border rounded-md bg-gray-50"
    onChange={handleCategoriaChangeEditar} // Maneja el cambio de categoría
    value={categoriaProductoCafeteriaIdEditar || ""} // Vincula el valor seleccionado al estado
>
    {datosListaCategoria.length > 0 ? (
        datosListaCategoria.map((categoria) => (
            <option 
                key={categoria.id} 
                value={categoria.id} // El value es el id
            >
                {categoria.nombre} 
            </option>
        ))
    ) : (
        <option disabled>Cargando categorías...</option> // Opción que se muestra si no hay categorías
    )}
</select>
              </div>
            </div>

            <div className="flex justify-center mt-6">
              <button className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700" onClick={handleEditarSubmit}>Guardar Cambios</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>      


      {/* Modal de Eliminar Producto */}
      <Modal show={show2} onHide={handleClose2} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {/* Mensaje de confirmación */}
        <p className="text-lg font-medium text-gray-700 mb-4">¿Está seguro de eliminar el producto seleccionado?</p>                
        </Modal.Body>   
        <Modal.Footer>
        {/* Botones de Confirmar y Cancelar */}
        <div className="flex justify-end space-x-4">
            <Button 
                variant="danger" 
                onClick={handleConfirmarEliminar} 
                className="bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 py-2 px-4 rounded-md"
            >
                Confirmar
            </Button>
            <Button 
                variant="secondary" 
                onClick={handleClose2} 
                className="bg-gray-500 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 py-2 px-4 rounded-md"
            >
                Cancelar
            </Button>
        </div>            
        </Modal.Footer>
      </Modal> 
        
      {/* Modal de editar categoria */}
      <Modal show={show4} onHide={handleClose4} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Editar Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card mb-8 p-6 bg-white rounded-md shadow-md">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Editar Categoria</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Nombre Categoria */}
              <div className="flex flex-col">
                <label htmlFor="nombre_categoria" className="text-sm font-medium text-gray-700">Nombre Categoria</label>
                <input type="text" id="nombre_categoria" value={nombreCategoriaEditar} onChange={handlerNombreCategoriaEditar} className="mt-2 p-3 border rounded-md bg-gray-50" required />
              </div>
            </div>

            <div className="flex justify-center mt-6">
              <button className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700" onClick={handleEditarCategoriaSubmit}>Guardar Cambios</button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose4}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Eliminar Categoria */}
      <Modal show={show5} onHide={handleClose5} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Categoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {/* Mensaje de confirmación */}
        <p className="text-lg font-medium text-gray-700 mb-4">¿Está seguro de eliminar la categoria seleccionada?</p>                
        </Modal.Body>   
        <Modal.Footer>
        {/* Botones de Confirmar y Cancelar */}
        <div className="flex justify-end space-x-4">
            <Button 
                variant="danger" 
                onClick={handleConfirmarEliminarCategoria} 
                className="bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 py-2 px-4 rounded-md"
            >
                Confirmar
            </Button>
            <Button 
                variant="secondary" 
                onClick={handleClose5} 
                className="bg-gray-500 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 py-2 px-4 rounded-md"
            >
                Cancelar
            </Button>
        </div>            
        </Modal.Footer>
      </Modal>

      </div>
    );            
}
export default Bodygestionproductos